import { cn } from '@distribute/frontend/utils';
import { FC, HTMLAttributes, PropsWithChildren } from 'react';

type Props = HTMLAttributes<HTMLTableCellElement> & {
  className?: string;
};

export const TableCell: FC<PropsWithChildren<Props>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <td
      {...props}
      className={cn(
        'first:border-l first:pl-4 first:rounded-l-xl last:pr-4 last:rounded-r-xl last:border-r',
        'pl-2 pr-2 border-y border-r-0 border-gray-200 flex-shrink-0 text-sm text-gray-700 truncate py-2',
        className
      )}
    >
      {children}
    </td>
  );
};
